import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <nav className="footer-nav">
          <a href="#products" className="nav-link footer-link">Products</a>
          <a href="#resource" className="nav-link footer-link">Resource</a>
          <a href="#company" className="nav-link footer-link">Company</a>
          <a href="#legal" className="nav-link footer-link">Legal</a>
        </nav>
        <div className="social-links">
          <a href="#facebook" className="social-icon">
            <img src="/icons/facebook.svg" alt="Facebook" />
          </a>
          <a href="#twitter" className="social-icon">
            <img src="/icons/twitter.svg" alt="Twitter" />
          </a>
          <a href="#instagram" className="social-icon">
            <img src="/icons/instagram.svg" alt="Instagram" />
          </a>
          <a href="#linkedin" className="social-icon">
            <img src="/icons/linkedin.svg" alt="LinkedIn" />
          </a>
        </div>
        <p className="footer-copyright">
          2025 Credithai.All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;